import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Pushes a virtual page view to the GTM dataLayer on every route change.
 * GTM triggers (GA4, Meta Pixel, etc.) can fire on the "page_view" event.
 */
export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
}
